import React from 'react'
import { Link, Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24ArrowRight24 } from '@is24/cosma-ui-icons'
import styles from './MarketRangeCtaNotification.module.css'

type MarketRangeCtaNotificationProps = {
  description: string
  onOpenDetails: () => void
}

export function MarketRangeCtaNotification({ description, onOpenDetails }: MarketRangeCtaNotificationProps) {
  const { t } = useTranslation()

  return (
    <Notification
      type='info'
      size='medium'
      variant='flat'
      title=''
      message={
        <div className={styles.message}>
          <span className={styles.description}>{description}</span>
          <Link
            className={`font-body-medium-bold ${styles.link}`}
            onClick={onOpenDetails}
            rightIcon={<IconS24ArrowRight24 />}
          >
            {t('wizard.screen.basicInfo.price.recommendedNotification.callToActionLink')}
          </Link>
        </div>
      }
    />
  )
}
